<div>

  <form [formGroup]="filterForm" (ngSubmit)="onFilter()" class="timesheet-form">
    <h5>Filter Categories</h5>
    <div class="form-row">
      
      @if (isAdmin) {
        <!-- Department Selection -->
      <div class="field">
         <mat-form-field appearance="outline">
          <mat-label>Department</mat-label>
          <mat-select formControlName="departmentIds" multiple="true">
            <mat-option>
              <ngx-mat-select-search
              [formControl]="departmentSearch.multiFilterCtrl"
              [placeholderLabel]="'Search Department'"
              [noEntriesFoundLabel]="'No Department Found'"
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="departmentSearch.isIndeterminate"
              [toggleAllCheckboxChecked]="departmentSearch.isChecked"
              (toggleAll)="departmentSearch.toggleSelectAll($event)"
              ></ngx-mat-select-search>
            </mat-option>
            @for (department of departmentSearch.filteredMulti | async; track department) {
              <mat-option [value]="department.id">{{department.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }
      
      <!-- CategoryType Selection -->
      <div class="field">
        <mat-form-field appearance="outline">
          <mat-label>Category Type</mat-label>
          <mat-select formControlName="categoryTypeIds" multiple="true">
            <mat-option>
              <ngx-mat-select-search
              [formControl]="categoryTypeSearch.multiFilterCtrl"
              [placeholderLabel]="'Search CategoryType'"
              [noEntriesFoundLabel]="'No CategoryType Found'"
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="categoryTypeSearch.isIndeterminate"
              [toggleAllCheckboxChecked]="categoryTypeSearch.isChecked"
              (toggleAll)="categoryTypeSearch.toggleSelectAll($event)"
              ></ngx-mat-select-search>
            </mat-option>
            @for (categoryType of categoryTypeSearch.filteredMulti | async; track categoryType) {
              <mat-option [value]="categoryType.id">{{categoryType.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      
      <!-- Category Selection -->
      <div class="field">
        <mat-form-field appearance="outline">
          <mat-label>Category</mat-label>
          <mat-select formControlName="ids" multiple="true">
            <mat-option>
              <ngx-mat-select-search
              [formControl]="categorySearch.multiFilterCtrl"
              [placeholderLabel]="'Search Category'"
              [noEntriesFoundLabel]="'No Category Found'"
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="categorySearch.isIndeterminate"
              [toggleAllCheckboxChecked]="categorySearch.isChecked"
              (toggleAll)="categorySearch.toggleSelectAll($event)"
              ></ngx-mat-select-search>
            </mat-option>
            @for (category of categorySearch.filteredMulti | async; track category) {
              <mat-option [value]="category.id">{{category.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <button mat-raised-button color="primary" type="submit">Filter</button>
      <button mat-raised-button color="primary" (click)="clearFilter()" type="button">Clear</button>
    </div>
  </form>

  <mat-paginator [length]="totalCategoryCount" [pageSize]="pageSize" 
  [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons 
  (page)="onPageChange($event)"></mat-paginator>
  <table mat-table [dataSource]="categoryList" class="demo-table">
    
    <!-- Category Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Category Name</th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ element.name }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <input matInput [(ngModel)]="element.name" required>
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Category Type Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Category Type </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ getCategoryName(element.categoryTypeId) }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <mat-select [(ngModel)]="element.categoryTypeId" required>
            <mat-option *ngFor="let type of typeList" [value]="type.id">{{ type.type }}</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- Department Column -->
    <ng-container matColumnDef="department">
      <th mat-header-cell *matHeaderCellDef> Department </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!element.editing">{{ getDepartmentName(element.departmentId) }}</span>
        <mat-form-field appearance="outline" *ngIf="element.editing">
          <mat-select [(ngModel)]="element.departmentId" required>
            <mat-option *ngFor="let department of departments" [value]="department.id">{{ department.departmentName }}</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>
    
    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button color="primary" *ngIf="!element.editing && !(userData.roleId == roleEnum.DEPARTMENT_ADMIN && element.isDefault)" (click)="editCategory(element)">Edit</button> &nbsp;
        <button mat-raised-button color="warn" *ngIf="!element.editing && !(userData.roleId == roleEnum.DEPARTMENT_ADMIN && element.isDefault)" (click)="deleteCategory(element)">Delete</button> &nbsp;
        <button mat-raised-button color="primary" *ngIf="element.editing && !(userData.roleId == roleEnum.DEPARTMENT_ADMIN && element.isDefault)" (click)="saveCategory(element)">Save</button> &nbsp;
        <button mat-raised-button *ngIf="element.editing && !(userData.roleId == roleEnum.DEPARTMENT_ADMIN && element.isDefault)" (click)="cancelEdit(element)">Cancel</button>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
